export enum DueDateRuleEnum {
  ON_ORDER_ACCEPTANCE = 'on_order_acceptance',
  DAYS_BEFORE_EVENT = 'days_before_event',
  ON_EVENT_DAY = 'on_event_day',
  DAYS_AFTER_EVENT = 'days_after_event',
}

export interface InstallmentPlanObj {
  name: string;
  value: number;
  dueDateRule: DueDateRuleEnum;
  days?: number;
}
